module.exports = __webpack_public_path__ + "assets/finance.69be456f.svg";